import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';
import isEmpty from 'lodash.isempty';
import cn from 'classnames';

import { short } from '../common/formatting/date';
import PatientDetails from './PatientDetails';
import { Link } from 'react-router-dom';

const RPMData = ({ user }) => {
	const userRaw = user.toJSON();
	const [selectedPatientId, setSelectedPatientId] = useState(null);
	const [searchValue, setSearchValue] = useState('');

	const [{ data: patients /* loading: loadingPatients */ }] = useAxios({
		url: `/providers/${userRaw.id}/vital-tracker-groups`,
	});

	const handlePatientClicked = ({ currentTarget }) => {
		setSelectedPatientId(currentTarget.dataset.patientid);
	};

	const handleClearSearch = () => {
		setSearchValue('');
	};

	let selectedPatient;
	if (patients && Array.isArray(patients)) {
		selectedPatient = patients.find(
			({ patientId }) => patientId == selectedPatientId
		);
	}

	return (
		<div className="content-wrapper rpm-data">
			<ol className="breadcrumb">
				<li>
					<Link to="/">Home</Link>
				</li>
				<li className="active">RPM Data</li>
			</ol>
			<div className="rpm-data-container">
				<div className="rpm-patient-list">
					<div
						className={cn('rpm-patient-list-search', 'form-group', {
							'has-feedback': searchValue.length > 0,
						})}
					>
						<input
							type="text"
							className="rpm-patient-list-search-input form-control form-control-rounded"
							disabled={!Array.isArray(patients)}
							placeholder="Patient Search"
							onChange={({ target }) => setSearchValue(target.value)}
							value={searchValue}
						/>
						<div
							className="fa fa-times form-control-feedback"
							aria-hidden={searchValue.length === 0}
							onClick={handleClearSearch}
						/>
					</div>
					{!Array.isArray(patients) ? (
						<span>Loading...</span>
					) : (
						patients
							.filter(
								({ name_first, name_last }) =>
									searchValue.length === 0 ||
									name_first
										.toLowerCase()
										.includes(searchValue.toLocaleLowerCase()) ||
									name_last
										.toLowerCase()
										.includes(searchValue.toLocaleLowerCase())
							)
							.map((patient) => (
								<div
									key={`${patient.patientId}`}
									className={cn('rpm-patient-list-item', {
										selected: patient.patientId == selectedPatientId,
									})}
									onClick={handlePatientClicked}
									data-patientid={patient.patientId}
								>
									<h3>
										{patient.name_first} {patient.name_last}{' '}
										<small>
											DOB:{' '}
											{!isEmpty(patient.birth_dttm) &&
												short(patient.birth_dttm.split('T')[0])}
										</small>
									</h3>
									<div>Gender: {patient.gender}</div>
									<div>
										{patient.address} {patient.city} {patient.state}{' '}
										{patient.zip}
									</div>
								</div>
							))
					)}
				</div>
				<PatientDetails patient={selectedPatient} userId={userRaw.id} />
			</div>
		</div>
	);
};

RPMData.propTypes = {
	user: PropTypes.object.isRequired,
};

export default RPMData;
